import './news.css';
import { React, useEffect, useState } from 'react';
import { useSearchParams, useNavigate, useParams, Link } from 'react-router-dom';
import getNewsInfo from '../../apis/get-news-info';

export const NewsPage = () => {
  const [searchParams, _] = useSearchParams();
  const { id } = useParams();

  const navigate = useNavigate();
  const [{ data, loading, error }, setNewsList] = useState({
    loading: false,
    data: null,
    error: null,
  });

  useEffect(() => {
    if (!id) {
      return;
    }
    const onMount = async () => {
      try {
        setNewsList((prev) => ({ ...prev, loading: true }));
        const data = await getNewsInfo(id);
        setNewsList((prev) => ({ ...prev, loading: false, data }));
      } catch (error) {
        setNewsList((prev) => ({ ...prev, loading: false, error: error }));
      }
    };

    onMount();
  }, [id]);

  // 에러 발생 시 에러 페이지로 이동
  useEffect(() => {
    if (error) {
      navigate('/error', {
        state: { message: error.message },
      });
    }
  }, [error, navigate]);

  if (loading || !data) {
    return null;
  }

  return (
    <div className="py-[30px] w-[90%] m-auto h-full flex flex-col items-center justify-center max-w-[500px]">
      <div className="w-full">
        <header id="conpick-headline">
          <Link to={'/'} className="px-[18px]">
            <svg
              className="conpick-logo-icon"
              width="39"
              height="20"
              viewBox="0 0 39 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.08 4C2.49333 4 2.07333 3.85333 1.82 3.56C1.56667 3.25333 1.44 2.89333 1.44 2.48C1.44 2.09333 1.56 1.75333 1.8 1.46C2.05333 1.16667 2.48 1.02 3.08 1.02H16.02C16.9 1.02 17.52 1.19333 17.88 1.54C18.24 1.87333 18.42 2.37333 18.42 3.04V5.02C18.42 5.92667 18.36 6.76667 18.24 7.54C18.12 8.31333 17.98 8.90667 17.82 9.32H13.94C14.0733 8.97333 14.1867 8.58 14.28 8.14H10.78V9.92H17.8C18.08 9.92 18.32 9.96667 18.52 10.06C18.72 10.1533 18.88 10.28 19 10.44C19.1333 10.5867 19.2267 10.7533 19.28 10.94C19.3333 11.1267 19.36 11.3133 19.36 11.5C19.36 11.6867 19.3267 11.8733 19.26 12.06C19.2067 12.2467 19.12 12.4133 19 12.56C18.88 12.7067 18.72 12.8267 18.52 12.92C18.32 13.0133 18.08 13.06 17.8 13.06H2.2C1.92 13.06 1.68 13.0133 1.48 12.92C1.28 12.8267 1.12 12.7067 1 12.56C0.88 12.4133 0.786667 12.2467 0.72 12.06C0.666667 11.8733 0.64 11.6867 0.64 11.5C0.64 11.3133 0.666667 11.1267 0.72 10.94C0.773333 10.7533 0.86 10.5867 0.98 10.44C1.11333 10.28 1.28 10.1533 1.48 10.06C1.68 9.96667 1.92 9.92 2.2 9.92H6.74V8.14H2.84C2.24 8.14 1.81333 8 1.56 7.72C1.32 7.44 1.2 7.08667 1.2 6.66C1.2 6.27333 1.32 5.93333 1.56 5.64C1.81333 5.34667 2.24 5.2 2.84 5.2H14.5V4.4C14.5 4.24 14.46 4.13333 14.38 4.08C14.3133 4.02667 14.2 4 14.04 4H3.08ZM4.5 19.52C3.94 19.52 3.47333 19.4667 3.1 19.36C2.72667 19.2667 2.43333 19.1067 2.22 18.88C2.00667 18.6533 1.85333 18.36 1.76 18C1.68 17.6267 1.64 17.1667 1.64 16.62V15.56C1.64 14.88 1.84667 14.4 2.26 14.12C2.67333 13.8267 3.16 13.68 3.72 13.68C4.28 13.68 4.75333 13.8267 5.14 14.12C5.54 14.4133 5.74 14.8933 5.74 15.56V16.06C5.74 16.2333 5.76667 16.3467 5.82 16.4C5.87333 16.44 5.99333 16.46 6.18 16.46H17.06C17.6733 16.46 18.1067 16.6133 18.36 16.92C18.6133 17.2267 18.74 17.58 18.74 17.98C18.74 18.3933 18.6067 18.7533 18.34 19.06C18.0867 19.3667 17.66 19.52 17.06 19.52H4.5ZM23.58 15.7C23.02 15.7 22.5867 15.5533 22.28 15.26C21.9867 14.9667 21.84 14.5867 21.84 14.12C21.84 13.6533 21.9867 13.2733 22.28 12.98C22.5867 12.6867 23.02 12.54 23.58 12.54H35.96C36.5867 12.54 37.0933 12.5867 37.48 12.68C37.8667 12.7733 38.1667 12.94 38.38 13.18C38.5933 13.42 38.7333 13.74 38.8 14.14C38.88 14.5267 38.92 15.02 38.92 15.62V19.52H34.88V16.18C34.88 15.86 34.72 15.7 34.4 15.7H23.58ZM22.26 11.38C21.7933 11.38 21.4267 11.2267 21.16 10.92C20.9067 10.6 20.78 10.26 20.78 9.9C20.78 9.54 20.9 9.22 21.14 8.94C21.38 8.64667 21.7533 8.5 22.26 8.5H22.62V6.82C22.62 6.22 22.7933 5.79333 23.14 5.54C23.5 5.27333 23.96 5.14 24.52 5.14C25.08 5.14 25.5333 5.27333 25.88 5.54C26.24 5.79333 26.42 6.22 26.42 6.82V8.5H28.06V6.82C28.06 6.22 28.2333 5.79333 28.58 5.54C28.94 5.27333 29.4 5.14 29.96 5.14C30.52 5.14 30.9733 5.27333 31.32 5.54C31.68 5.79333 31.86 6.22 31.86 6.82V8.5H32.54C33.0467 8.5 33.42 8.64667 33.66 8.94C33.9 9.22 34.02 9.54 34.02 9.9C34.02 10.26 33.8867 10.6 33.62 10.92C33.3667 11.2267 33.0067 11.38 32.54 11.38H22.26ZM34.78 2.72C34.78 2.06667 34.98 1.57333 35.38 1.24C35.7933 0.906666 36.2667 0.739999 36.8 0.739999C37.0533 0.739999 37.3 0.786666 37.54 0.879999C37.7933 0.959999 38.0133 1.08667 38.2 1.26C38.3867 1.42 38.5333 1.62667 38.64 1.88C38.76 2.12 38.82 2.4 38.82 2.72V11.76H34.78V2.72ZM22.52 4.44C22.28 4.44 22.0667 4.39333 21.88 4.3C21.7067 4.20667 21.5533 4.08667 21.42 3.94C21.3 3.79333 21.2067 3.62667 21.14 3.44C21.0733 3.25333 21.04 3.06667 21.04 2.88C21.04 2.69333 21.0667 2.50667 21.12 2.32C21.1867 2.13333 21.28 1.96667 21.4 1.82C21.52 1.67333 21.6733 1.55333 21.86 1.46C22.0467 1.36667 22.2667 1.32 22.52 1.32H31.86C32.1133 1.32 32.3333 1.36667 32.52 1.46C32.7067 1.55333 32.86 1.67333 32.98 1.82C33.1 1.96667 33.1867 2.13333 33.24 2.32C33.3067 2.50667 33.34 2.69333 33.34 2.88C33.34 3.06667 33.3067 3.25333 33.24 3.44C33.1733 3.62667 33.0733 3.79333 32.94 3.94C32.82 4.08667 32.6667 4.20667 32.48 4.3C32.3067 4.39333 32.1 4.44 31.86 4.44H22.52Z"
                fill="#212121"
              ></path>
            </svg>
          </Link>
          <h2 id="conpick-headline-title">{data.Title}</h2>
          <p id="conpick-headline-info">
            <span id="conpick-media">{data.MediaName}</span>
            <span id="conpick-datestamp">{data.PubDateTime}</span>
          </p>
        </header>
        <div
          dangerouslySetInnerHTML={{
            __html: data.Description.replace(/style="[^"]*"/g, '')
              .replace(/width="[^"]*"/g, '')
              .replace(/height="[^"]*"/g, ''),
          }}
        />
      </div>
    </div>
  );
};
